import { useState, useEffect } from "react";
import { getSumOfArrayOfObjects } from "../../utils/calcHelpers";
import useCustomerCharges from "../useCustomerCharges/useCustomerCharges";

export default function useOfferCalculations(load, commissionVariables) {
  const { customerLinehaul, customerFuel } = useCustomerCharges(load);
  const [customerCharges, setCustomerCharges] = useState(0);
  const [targetPay, setTargetPay] = useState(0);
  const [targetProfit, setTargetProfit] = useState(0);
  const [targetMargin, setTargetMargin] = useState(0);
  const [targetCommission, setTargetCommission] = useState(0);
  const [offerAmount, setOfferAmount] = useState("");
  const [offerProfit, setOfferProfit] = useState(0);
  const [offerMargin, setOfferMargin] = useState(0);
  const [offerCommission, setOfferCommission] = useState(0);
  const [maxPay, setMaxPay] = useState(0);
  const [maxProfit, setMaxProfit] = useState(0);
  const [maxMargin, setMaxMargin] = useState(0);
  const [maxCommission, setMaxCommission] = useState(0);
  const [difference, setDifference] = useState(0);

  useEffect(() => {
    const totalFuel = getSumOfArrayOfObjects(customerFuel, "amount");
   
    setTargetPay(load.targetPay);
    setMaxPay(load.maxPay);
    setCustomerCharges(customerLinehaul + totalFuel);
  }, [load, customerLinehaul, customerFuel]);

  useEffect(() => {
    setTargetProfit(customerCharges - targetPay);
    setMaxProfit(customerCharges - maxPay);
  }, [targetPay, maxPay, customerCharges]);

  useEffect(() => {
    if (customerCharges > 0) {
      setTargetMargin(targetProfit / customerCharges);
      setMaxMargin(maxProfit / customerCharges);
      setOfferMargin(offerProfit / customerCharges);
    }

  }, [targetProfit, offerProfit, maxProfit, customerCharges]);

  useEffect(() => {
    setOfferProfit(customerCharges - offerAmount);
    setDifference(customerCharges - offerAmount);
  }, [offerAmount, customerCharges]);

  useEffect(() => {
    const calculateCommissions = (value) => {
      const commissionActual = value * commissionVariables.commissionPercent;

      if (commissionActual > commissionVariables.commissionMin) {
        return commissionActual;
      } else {
        return commissionVariables.commissionMin;
      }
    }; 
    
    setTargetCommission(calculateCommissions(targetProfit));
    setOfferCommission(calculateCommissions(offerProfit));
    setMaxCommission(calculateCommissions(maxProfit));  

  }, [commissionVariables, targetProfit, offerProfit, maxProfit]);

  return {
    customerCharges,
    targetPay,
    targetProfit,
    targetMargin,
    targetCommission,
    offerAmount,
    setOfferAmount,
    offerProfit,
    offerMargin,
    offerCommission,
    maxPay,
    maxProfit,
    maxMargin,
    maxCommission,
    difference
  };
}